var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./BenefitsHealthPopup.jinja');
require('./BenefitsHealthPopup.less');

var CommonSidebar = require('front/components/CommonSidebar/CommonSidebar');
var CommonStory = require('front/components/CommonStory/CommonStory');

module.exports = BasePopup.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonSidebar': {selector: '.CommonSidebar', viewConstructor: CommonSidebar},
        'CommonStory': {selector: '.CommonStory', viewConstructor: CommonStory}
    },

    events: _.extend({

    }, BasePopup.prototype.baseEvents),


    apiUrl: function () {
        return Urls['front:api:benefits_health-popup']();
    },


    initialize: function (options) {
        this.options = options || {};

        BasePopup.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/BenefitsHealthPopup/BenefitsHealthPopup.js
// module id = 256
// module chunks = 0